import { Button } from '@fluentui/react-components';
import { Home20Regular, QuestionCircle24Regular } from '@fluentui/react-icons';
import { useNavigate, type ErrorComponentProps } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRuntime } from '@/app/providers/runtime-provider';
import { ErrorPage } from './error-page';
import { FullPageState } from './full-page-state';

/** Error component of the root route: reports the error, then shows the plain error page. */
export function RootError({ error, info, reset }: ErrorComponentProps) {
  const { errorReporter } = useRuntime();
  useEffect(() => {
    errorReporter.report('boundary', error, { componentStack: info?.componentStack });
  }, [error, info, errorReporter]);
  return <ErrorPage error={error} onRetry={reset} />;
}

/** Not-found component of the root route. */
export function NotFound() {
  const { t } = useTranslation('web');
  const navigate = useNavigate();
  return (
    <FullPageState
      icon={<QuestionCircle24Regular />}
      title={t('notFound.title')}
      actions={
        <Button
          appearance="primary"
          icon={<Home20Regular />}
          onClick={() => {
            void navigate({ to: '/' });
          }}
        >
          {t('notFound.home')}
        </Button>
      }
    >
      {t('notFound.body')}
    </FullPageState>
  );
}
